export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Final2_04.bfd67017.jpg";